define(function (require, exports) {
    'use strict';
    var sdkinit = require('XmSdk');
    // @ngInject
    exports.metScaPayment = function (TEMPLATE_PATH, lpCoreI18n) {
        return {
            restrict: 'E',
            scope: {
                startjourney: '=?startjourney',
                canceljourney: '&',
                endjourneyfirst: '&',
                request: '=?request',
                submit: '&submit',
                startregistration:'=?startregistration'
            },
            controller: /* @ngInject */ function ($scope, $timeout, $element, $log, metroTransmit, metroUiHandler, lpCoreBus, lpUsersAuthentication,metroContext, metroMeta, metroTagging) {

                $scope.endjourneyfirst;
                var resolveSoftTokenPromise;
                var forms = ['COB_SCA_NO_HT_form', 'COB_SCA_HT_form', 'COB_SCA_ST_form','hrp_cob_soft_token_password_form', 'COB_SCA_ST_PW_form', 'cob_mobile_auth_registration_form']; //'hard_token_form',
                var currentScenario = null;
                var errSoftokenFailure;
                var hrpDataRequest;

                $scope.formLoad = false;
                $scope.modalHeader = "";
                var authJourney;
                $scope.$watch('startjourney', function (newValue) {
                    metroUiHandler.resetJsonProviderData()
                    $scope.hrp = {};
                    $scope.isSoftokenJourney = false;
                    $scope.isBulkBatchJourney = false;
                    $scope.softokenDeclined = false;
                    $scope.modalHeader = "";
                    $scope.totpQRImage = "";
                    //to do : remove 1 flag
                    $scope.softokenPasswordJourney = false;
                    errSoftokenFailure = "";
                    $scope.userId = JSON.parse(localStorage.getItem('session')).username;
                    if (newValue) {
                        if($scope.request && $scope.request.payment_amount){
                            if($scope.request.payment_ccy){
                                $scope.payment_ccy = $scope.request.payment_ccy;
                            }
                            $scope.decimalfy();
                        }
                        authJourney = "payment_authentication_journey"
                        var subjourney = ($scope.request && $scope.request.sub_flow_type1 )? $scope.request.sub_flow_type1 : '';
                        metroUiHandler.setJourney('user_hrp_journey', subjourney);

                        if ($scope.request.sub_flow_type1) {
                            switch ($scope.request.sub_flow_type1) {
                                case 'standing_order':
                                case 'amend_payment_items':
                                case 'recurring_transfers':
                                case 'single_held_transactions':
                                case 'single_payment_new_payee': 
                                case 'batch_payment':
                                case 'outstanding_payments_management':    
                                case 'bulk_payment':{
                                    $scope.modalHeader = "Authenticating a payment";
                                    break;
                                }
                                case 'beneficiary':
                                case 'bulk_ben':
                                case 'mandates':  
                                case 'account_groups':
                                case 'user':
                                case 'access_groups': {
                                    $scope.modalHeader = "Update your information";
                                    break;
                                }
                                case 'password-update': {
                                    $scope.modalHeader = "Update Password";
                                    authJourney = "user_change_password_journey"
                                    break;
                                }
                                default: {
                                    $scope.modalHeader = "Process";
                                }
                            }
                        }

                        if($scope.request.isScaCards){
                            
                            if($scope.request.isPA){
                                $scope.modalHeader = "Authenticating online payments";
                            }else{
                                $scope.modalHeader = "Authenticating your card";
                            }

                            metroTagging.onpageLoadTag(
                                'Card Ecommerce | Metrobank',
                                document.location.pathname+"/modal-sca-stepup/"+$scope.modalHeader.toLowerCase().replace(" ", "-"),
                                metroMeta.EVENT.pageLoaded);

                            /* Card approve journey  COB-SCA-G003*/
                            metroTagging.onEventTag(metroMeta.EVENTNAME.goal,
                                $scope.request.isPA ? metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHAPPROVAL : metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHCARDAPPROVAL,
                                metroMeta.TRANSMIT.SCA.CARDAPPROVALJOURNEYSTARTEVENTDETAIL,
                                metroMeta.EVENT.goal);

                        }

                        $scope.modulename = metroTransmit.formatMdoduleString($scope.request);


                        //$scope.request.isLocal=true;
                        metroTransmit.invokePolicy(authJourney, $scope.request, null).then(function (response) {
                            if (response._internalData.json_data.authentication_policy /* && response._internalData.json_data.authentication_policy !== "EXEMPTED" */) {
                                if(response._internalData.json_data.authentication_policy !== "EXEMPTED"){
                                    $scope.startProcess();
                                }
                                $scope.request.authentication_policy = response._internalData.json_data.authentication_policy;
                                hrpDataRequest = angular.copy($scope.request);
                                if(hrpDataRequest && hrpDataRequest.payment_ccy){
                                    var currencySymbol = lpCoreI18n.formatCurrency(0, hrpDataRequest.payment_ccy);
                                    currencySymbol = currencySymbol.toString();
                                    currencySymbol = currencySymbol.split('0')[0];
                                    if(currencySymbol){
                                        hrpDataRequest.payment_ccy = currencySymbol;
                                    }
                                }
                                hrpjourney();
                            }
                            else if(response._internalData.json_data.updated_password == true){
                                $scope.endProcess(null, null, true);
                            }
                            else {
                                const jwt = sessionStorage.getItem('sessionJwt');
                                $scope.endProcess(jwt, null);
                            }
                        }).catch(function (err) {
                            $scope.loading = false;
                            const error = err._data;

                            if(metroUiHandler.getKeyValue("softokenErrorMessage")){
                                errSoftokenFailure = metroUiHandler.getKeyValue("softokenErrorMessage")
                            }
                            if(authJourney === 'user_change_password_journey'){
                                let errormsg = 'generic';
                                if ((error && error.failure_data && error.failure_data.reason && error.failure_data.reason.data) || errSoftokenFailure) {
                                    if(error.failure_data && error.failure_data.reason.data.password_constraint_error == true) {
                                        errormsg = "passwordconstrainerror";
                                    }
                                    else if ((error.failure_data && (error.failure_data.reason.data.incorrect_attempt || error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL")) 
                                        ||  (errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL")) {
                                        errormsg = "incorrect";
                                    }
                                    else if ((error.failure_data && (error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING" )) 
                                        ||  (errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING")) {
                                        errormsg = "oneattemptleft";
                                    } 
                                    else if (error.failure_data.reason.data.errors[0].id == "SCACHK_PROCESS_BLOCKED") {
                                        errormsg = "blockedprocess";
                                    }
                                    else if ((error.failure_data && (error.failure_data.reason.data.account_locked || error.failure_data.reason.data.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT")) 
                                        || (errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING")) {
                                        window.sessionStorage.setItem('qParams',JSON.stringify({'locked':true}));    
                                        lpUsersAuthentication.logOut();
                                        return true;
                                    }
                                    else {
                                        errormsg = "generic";
                                    }
                                }else if(metroUiHandler.getKeyValue("login_cross_session_id") && metroUiHandler.getKeyValue("softokenError")){
                                    errormsg = "incorrect";
                                }
                                
                                let errArray = null;
                                errArray = metroTransmit.handleError(errormsg);
                                $scope.endProcess(null, errArray);
                            }else{
                                let errArray = null;
                                errArray = metroTransmit.handleError('generic');
                                $scope.endProcess(null, errArray);
                            }
                            
                        });
                    }
                });


                $scope.$watch('startregistration', function (newValue) {
                    $scope.registrationButtonText =  ($scope.request && ($scope.request.business_flow =="HRP") || ($scope.request && $scope.request.sub_flow_type1 == "password-update")) ? "Continue" : "Continue to Payment";
                    if (newValue) {
                        metroUiHandler.setJourney('soft_token_registration');
                        $scope.cancelProcess();
                        $scope.showPaymentModal = false
                        $scope.RegistrationStep = 0;
                        $scope.showRegistrationModel = true;
                        $timeout( function(){
                            $scope.RegistrationStep = 0;
                            $scope.startSoftTokenProcess();
                         }, 3000);

                         if (!$scope.$$phase) {
                            $scope.$apply();
                          }
                    }
                });


                var scenario = {
                    "hard_token_form": {
                        fields: ['htoken']
                    },
                    "COB_SCA_HT_form": {
                        fields: ['pwd', 'htoken']
                    },
                    "COB_SCA_ST_form": {
                        fields: ['pwd', 'stoken']
                    },
                    "COB_SCA_ST_PW_form": {
                        fields: ['stoken']
                    },
                    "hrp_cob_soft_token_password_form":{
                        fields: ['pwd', 'stoken']
                    }
                }
                $scope.decimalfy = function(){
                    $scope.display_amt = angular.copy($scope.request.payment_amount) + '';
                    $scope.display_device_sec = '';
                    var splitnumber = $scope.display_amt.toString().split('.');
                    if(splitnumber.length == 1 && splitnumber[0] > 0){
                        $scope.display_device_sec = splitnumber[0]+"00";
                        $scope.display_amt = splitnumber[0]+".00";
                      }
                      else if(splitnumber.length == 2 && splitnumber[0] > 0 && splitnumber[1].toString().length == 1){
                        $scope.display_device_sec = $scope.display_amt+"0";
                        $scope.display_amt = $scope.display_amt.toString()+"0";
                      }
                      else if(splitnumber.length == 2 && splitnumber[0] == 0 && splitnumber[1].toString().length == 1){
                        $scope.display_device_sec = splitnumber[1]+"0";
                        $scope.display_amt = $scope.display_amt.toString()+"0";
                      }
                      else if(splitnumber.length == 2 && splitnumber[0] == 0 && splitnumber[1].toString().length == 2){
                        if(splitnumber[1].toString().indexOf('0') == 0){
                            $scope.display_device_sec = splitnumber[1].substring(1);
                        }else{
                            $scope.display_device_sec = splitnumber[1];
                        }                    
                        $scope.display_amt = $scope.display_amt;
                      }
                      else {
                        $scope.display_device_sec = splitnumber.join("")
                        $scope.display_amt = $scope.display_amt;
                      }
                }

                /* softoken  registration app */
                $scope.cancelMobileApproval = function(){
                    if(!$scope.fakeSoftTokenForm){
                        var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.SelectMethod);
                        if ($scope.resolveCancelMobileApproval) {
                            $scope.resolveCancelMobileApproval(com.ts.mobile.sdk.InputOrControlResponse.createControlResponse(controlRequest));
                        }
                    }
                    else {
                        $scope.showTotpInput = true;
                        $scope.hrp.stoken = ""
                    }
                }

                $scope.downloadapp = function(market, storeText) {
                    $scope.srcPath = "data:image/jpeg;base64," + $scope.QRObject[market+"_app_qr"];
                    $scope.storeName = storeText;
                    $scope.RegistrationStep = 2;
                }

                $scope.cancel = function(){
                    $scope.RegistrationStep = 1
                }

                $scope.startRegistrationProcess = function(){
                    $scope.startregistration = true;
                }

                $scope.startAuthenticate = function(neverShow) {
                    var obj = {
                        "provision_mobile_auth_reg" : true
                    }
        
                    if(neverShow){
                        obj = {
                            "never_promote" : true
                        }
                    }

                    metroUiHandler.resolvePromise('soft_token_registration', obj);
                }

                $scope.startSoftToken = function(){
                    $scope.startSoftTokenProcess();
                }

                $scope.softokenFailureLoginResponse = function(){
                    var session = metroContext.getSession();
                    var stepUpRequest = {"login_cross_session_id" : metroUiHandler.getKeyValue("login_cross_session_id"), "id":session.username}
                    
                    //console.log(stepUpRequest)
                    metroTransmit.invokeAnonymousPolicy("get_loggin_fail_rule_response",stepUpRequest, null )
                        .then( function (res) {
                            alert("sucess");
                        })
                        .catch(function(err){
                            $scope.loading = false;
                            const error = err._data;
                            let errArray = null;
                            let errormsg = "generic";
                            if (error && error.failure_data && error.failure_data.reason && error.failure_data.reason.data) {
                                    if (error.failure_data.reason.data.incorrect_attempt || error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL") {
                                        errormsg = "incorrect";
                                    }
                                    if (error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING") {
                                        errormsg = "oneattemptleft";
                                    }
                                    if (error.failure_data.reason.data.account_locked || error.failure_data.reason.data.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT") {
                                        window.sessionStorage.setItem('qParams',JSON.stringify({'locked':true}));    
                                        lpUsersAuthentication.logOut();
                                        return true;
                                    }
                            }
                            errArray = metroTransmit.handleError(errormsg);
                            $scope.endProcess(null, errArray);
                        });
                
                }

                $scope.startSoftTokenProcess = function(){
                    metroTransmit.invokePolicy("cob_enroll_mobile_authenticator", null, null )
                        .then( function (res) {
                            $scope.startjourney = false;
                            $scope.showPaymentModal = false;
                            $scope.cancelMobileApproval();
                            $scope.startregistration = false
                            $scope.RegistrationStep = "";
                            $scope.showRegistrationModel = false;
                            for (let element = 0; element < scenario[currentScenario].fields.length; element++) {
                                $scope['show' + scenario[currentScenario].fields[element]] = false;
                                if ($scope.hrp) {
                                    $scope.hrp[scenario[currentScenario].fields[element]] = '';
                                }
                            }
                            $scope.isSoftokenJourney = true;
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                        })
                        .catch(function(err){
                            $scope.cancelProcess('registration');
                            console.log("Error in Registration")
                        });
                }
        

                /* softoken  registration app */

                $scope.startProcess = function () {
                    $scope.isSoftokenJourney = false;
                    $scope.showstoken = false;
                    $scope.showTotpInput = false;

                    for (let form = 0; form < forms.length; form++) {
                        lpCoreBus.unsubscribe('user_hrp_journey.uiHandler.' + forms[form]);
                        lpCoreBus.subscribe('user_hrp_journey.uiHandler.' + forms[form], function (obj) {
                            window.ga('send', 'pageview',forms[form]);
                            
                            if (obj && obj.softToken) {
                                $scope.isSoftokenJourney = true;
                                $scope.showTotpInput = false;

                                $scope.resolveCancelMobileApproval = obj.promiseResolve
                                $scope.endAuthenticatorSession = obj.endSession;
                            }
                            if(obj && obj.lastFourDigits){
                                $scope.ibanlastFourDigits = obj.lastFourDigits
                            }

                            currentScenario = forms[form];
                            
                            if(currentScenario == "hrp_cob_soft_token_password_form"){
                                $scope.softokenPasswordJourney = true;
                                
                            }
     
                            for (let element = 0; element < scenario[currentScenario].fields.length; element++) {
                                $scope['show' + scenario[currentScenario].fields[element]] = true;
                                if ($scope.hrp) {
                                    $scope.hrp[scenario[currentScenario].fields[element]] = '';
                                }

                            }

                            if($scope.request.isScaCards){
                                $scope.showPaymentModal = true;
                                lpCoreBus.publish('hide-cards-modal');
                            }

                            $scope.formLoad = true;
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                            
                        });
                    }
                    if(!$scope.request.isScaCards){
                        $scope.showPaymentModal = true;
                    }
                    $scope.showPaymentModal = true;
                    $scope.formLoad = false;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }

                lpCoreBus.subscribe('user_payment_journey.uiHandler.showQRcode', function(QrImage){
                    $scope.totpQRImage= "data:image/jpeg;base64," + QrImage;
                })

                lpCoreBus.subscribe('softoken-declined', function(){
                    $scope.softokenDeclined = true;
                })

                $scope.contentSoftotokeUIHandler = function(isBioDisabled){
                    $scope.isBiomatricDisabled = isBioDisabled;
                }

                lpCoreBus.subscribe('contentSoftotokeUIHandler', function (isBioDisabled) {
                    $scope.contentSoftotokeUIHandler(isBioDisabled)
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                })

                lpCoreBus.subscribe('user_hrp_journey.uiHandler.hard_token_form', function () {
                    currentScenario = 'hard_token_form';
                    $scope.startProcess();
                    $scope.showhtoken = true;
                    if ($scope.hrp) {
                        $scope.hrp.htoken = '';
                    }
                    $scope.formLoad = true;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });

                lpCoreBus.subscribe('scaEnabled', function (flag) {
                    $scope.disabledSoftoken = flag
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });

                lpCoreBus.subscribe('user_hrp_journey.uiHandler.COB_SCA_ST_PW_form', function(obj){
                    if (obj && obj.softToken) {
                        $scope.isSoftokenJourney = true;
                        $scope.showTotpInput = false;
                        $scope.resolveCancelMobileApproval = obj.promiseResolve
                        $scope.endAuthenticatorSession = obj.endSession;
                    }
                    
                    $scope.isSoftokenJourney = true;
                    currentScenario = "COB_SCA_ST_PW_form";
                    for (let element = 0; element < scenario[currentScenario].fields.length; element++) {
                        $scope['show' + scenario[currentScenario].fields[element]] = true;
                        if ($scope.hrp) {
                            $scope.hrp[scenario[currentScenario].fields[element]] = '';
                        }

                    }
                    $scope.showPaymentModal = true;
                    $scope.formLoad = true;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }  
                })


                lpCoreBus.subscribe('soft_token_registration.uiHandler.cob_mobile_auth_registration_form', function  (payload) {
                        $scope.RegistrationStep = 1;
                        $scope.stopLoader = true;
                        $scope.QRObject =payload;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                })

                lpCoreBus.subscribe('user_hrp_journey.uiHandler.showTotp', function (resolve) {
                    $scope.showTotpInput = true;
                    $scope.showpwd = false;
                    $scope.isSoftokenJourney= true;
                    $scope.hrp.stoken = ""
                    resolveSoftTokenPromise = resolve
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                })

                lpCoreBus.subscribe('loadTickeUi', function (ticketWaitInfo) {
                    $scope.ticketWaitInfo = ticketWaitInfo;
                    $scope.loadTicketInfoToUi();
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                })


                $scope.loadTicketInfoToUi = function(){
                    $scope.RegistrationStep = 3;
                    if ($scope.ticketWaitInfo) {
                        if ($scope.ticketWaitInfo.getTicketId()) {
                            try {
                                switch ($scope.ticketWaitInfo.getTicketId().getFormat()) {
                                    case com.ts.mobile.sdk.TicketIdFormat.Alphanumeric:
                                        console.log("alphanumeric")
                                        break
                                    case com.ts.mobile.sdk.TicketIdFormat.Qr:
                                        $scope.QRmapImage = "data:image/jpeg;base64," + $scope.ticketWaitInfo.getTicketId().getValue();
                                        break;
                                    default:
                                }
                            }
                            catch (e) {
                                this.common.log("Error in loadTicketInfoToUi(), not displaying ticket : " + e);
                            }
                        }
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }


                $scope.submitForm = function () {

                    $scope.messages = ""
                    /* GA Tagging COB-SCA-BA007*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                       metroMeta.EVENTACTION.sca,
                       $scope.modalHeader.toLowerCase()+": next",
                       metroMeta.EVENT.buttonAction);

                    $scope.loading = true;
                    if ($scope.hrp && !$scope.isSoftokenJourney) {
                        if (currentScenario === 'hard_token_form') {
                            metroUiHandler.resolvePromise('user_hrp_journey', {
                                hardtoken: $scope.hrp.htoken,
                            });
                        }
                        if (currentScenario === 'COB_SCA_HT_form') {
                            metroUiHandler.resolvePromise('user_hrp_journey', {
                                hardtoken: $scope.hrp.htoken,
                                password: $scope.hrp.pwd
                            });
                        }
                        if (currentScenario === 'hrp_cob_soft_token_password_form') {
                            $scope.loading = false;
                            metroUiHandler.resolvePromise('user_hrp_journey', {
                                password: $scope.hrp.pwd
                            });
                        }
                        
                    }
                    else if($scope.isSoftokenJourney) {
                        $scope.validateSoftToken();
                    }
                    
                }

                $scope.validateSoftToken = function () {
                    //TO DO  promise resolve is not correct
                    if( $scope.fakeSoftTokenForm ){
                        var obj = {
                            totp: $scope.customer.passcode
                        }
                        var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(obj);
                        metroUiHandler.resolvePromise(formInput);
                    }
                    else{
                        let codeSubmission = com.ts.mobile.sdk.impl.TotpInputCodeSubmissionImpl.createTotpCodeSubmission($scope.hrp.stoken);
                        let targetAuthInput = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(codeSubmission);
                        resolveSoftTokenPromise.resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(targetAuthInput));
                    }
                }

                

                $scope.cancelProcess = function(startregistration){
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        $scope.modalHeader.toLowerCase()+": cancel",
                        metroMeta.EVENT.buttonAction);

                    if($scope.isBiomatricDisabled && $scope.request.isScaCards) { 
                           $scope.endProcess($scope.startregistration?'registration':'cancel', null, null);
                           $scope.RegistrationStep = "";
                           $scope.showRegistrationModel = false;
                           $scope.isBiomatricDisabled = false;
                    }
                    else{
                        metroTransmit.reinitialize().then(function(){
                            $scope.startjourney = false;
                            $scope.showPaymentModal = false;
                            $scope.cancelMobileApproval();
                        //  $scope.canceljourney();
                            if(startregistration){
                                $scope.startregistration = false
                                $scope.RegistrationStep = "";
                                $scope.showRegistrationModel = false;
                                $scope.isBiomatricDisabled = false;
                            }
                            if($scope.request.isScaCards){
                                 $scope.endProcess($scope.startregistration?'registration':'cancel', null, null);
                            }
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                        })
                    }
                }

                var hrpjourney = function(){
                    metroTransmit.invokePolicy('user_hrp_journey', { 'hrp_data_json': hrpDataRequest }, null).then(function (response) {
                        $scope.loading = false;
                        $scope.endProcess(response._token, null);
                    }).catch(function (err) {
                        // Password incorrect then only below if block need to works
                        if(metroUiHandler.getKeyValue("softokenErrorMessage") ){
                            errSoftokenFailure = metroUiHandler.getKeyValue("softokenErrorMessage")
                        }

                        if(err && err._data && err._data.failure_data && err._data.failure_data.reason && err._data.failure_data.reason.data
                          && (err._data.failure_data.reason.data.is_biometric_enabled == false)){
                            $scope.showTotpInput = false;
                            $scope.isBiomatricDisabled = true;
                            $scope.isSoftokenJourney = true;
                            $scope.showstoken = true;
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                        }
                        // Password correct and have TOTP then only below if block need to works
                        if ( !$scope.softokenDeclined && !errSoftokenFailure && (metroUiHandler.getKeyValue("login_cross_session_id") || metroUiHandler.getKeyValue("softokenError"))) {
                            if (!$scope.biomatricDisabled) {
                                    $scope.softokenFailureLoginResponse();
                            }  else {
                                let errormsg = "generic";
                                let errArray = metroTransmit.handleError(errormsg);
                                $scope.loading = false;
                                $scope.startjourney = false;
                                $scope.showPaymentModal = false;
                                if (!$scope.$$phase) {
                                    $scope.$apply();
                                }
                                $scope.endjourneyfirst({ jwt: null, error: errArray});
                            }
                        }
                        else {
                            $scope.loading = false;
                            const error = err._data;
                            let errArray = null;
                            let errormsg = "generic";
                            if ((error && error.failure_data && error.failure_data.reason && error.failure_data.reason.data) || errSoftokenFailure) {
                                console.log("inner if condition")
                                if ((error.failure_data && error.failure_data.reason.data && (error.failure_data.reason.data && error.failure_data.reason.data.incorrect_attempt || error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL"))
                                    || (errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL")) {
                                    errormsg = "incorrect";
                                }
                                if ((error.failure_data && error.failure_data.reason.data && (error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING"))
                                    || (errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING")) {
                                    errormsg = "oneattemptleft";
                                }
                                if ((error.failure_data && error.failure_data.reason.data && (error.failure_data.reason.data.account_locked || error.failure_data.reason.data.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT"))
                                    || (errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT")) {
                                    window.sessionStorage.setItem('qParams', JSON.stringify({ 'locked': true }));
                                    lpUsersAuthentication.logOut();
                                    return true;
                                }
                            } else if (metroUiHandler.getKeyValue("login_cross_session_id") && metroUiHandler.getKeyValue("softokenError")) {
                                errormsg = "incorrect";
                            }
                            errArray = metroTransmit.handleError(errormsg);
                            $scope.endProcess(null, errArray);
                        }
                    });
                }
                
                 $scope.eventtracker = function(eventvalue){
                    /* Card approve journey  COB-SCA-N001 && ID : COB-SCA-N002*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.textentry,
                        metroMeta.EVENTACTION.sca,
                        $scope.modalHeader.toLowerCase()+":"+eventvalue,
                        metroMeta.EVENT.textentry);
                }

                $scope.endProcess = function (jwtvalue, error, updatePassword) {//updatePassword
                    $scope.loading = false;
                    if($scope.request.isScaCards && error && error[0].responseCode !== "LOGIN_GENERIC"){
                        $scope.messages = error;
                        $scope.showstoken = false;
                        $scope.showTotpInput = false;
                        $scope.startProcess();
                        /* Card approve journey  COB-SCA-N001 */
                        metroTagging.onEventTag(metroMeta.EVENTNAME.notification,
                        metroMeta.EVENTACTION.popup,
                        $scope.modalHeader.toLowerCase() +": check details and try again",
                        metroMeta.EVENT.notification);
                        
                        
                        hrpjourney();
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                    else 
                    {
                        
                        if ($scope.endAuthenticatorSession) {
                            $scope.endAuthenticatorSession();
                        }
                        $scope.cancelMobileApproval()
                        $scope.startjourney = false;
                        $scope.showPaymentModal = false;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                        $scope.endjourneyfirst({ jwt: jwtvalue, error: error, isPasswordUpdate: updatePassword});
                    }
                }
                lpCoreBus.subscribe('cancel-sca-journey-international-page', function() {
                    $scope.cancelProcess();
                });
            },
            templateUrl: TEMPLATE_PATH + 'metScaPayment.html'
        };
    };


    exports.metOnlyNumber = function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.push(function (val) {
                    if (!val) return '';

                    var clean = val.replace(/\D+/g, '');
                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });
            }
        };
    };

});


// WEBPACK FOOTER //
// ./scripts/directives/metScaPayment.js